import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import Resume from "../resume.pdf";
import profileImage from "../assets/img/profile-pic.jpeg";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const toRotate = ["Ideate", "Design", "Create"];
  const [text, setText] = useState(" ");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }
    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <h1 className="glow">{`Hi, I'm Vicheda`}</h1>
            <h2>
              <span className="wrap">{text}</span>
            </h2>
            <p>
              <i>
                BS/MS in <b>Computer Science</b> (Combined Program) @
                Northwestern University
              </i>
            </p>
            <p>
              <i>Concentration in Artificial Intelligence (Class of 2027)</i>
            </p>
            <div className="about-text-inline">
              <p>
                I build technology that creates meaningful impact from AI
                applications to full-stack applications! Outside of engineering,
                I build for others (in a different way) by leading community projects in Cambodia, teaching, learning, providing access to tech education, and building an empowering community :)
              </p>
            </div>
            <button
              onClick={() => {
                window.open(Resume, "_blank");
              }}
            >
              My Resume
              <ArrowRightCircle size={25} />
            </button>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <div className="about-image-container">
              <img
                src={profileImage}
                alt="Vicheda Narith"
                className="banner-profile-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};